import * as React from 'react';

export const CalendarRusal = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M13.111 1a1 1 0 0 1 .993.883l.007.117v.555H15a3 3 0 0 1 2.995 2.824l.005.177v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3l.888-.001V2a1 1 0 0 1 1.994-.117L7.89 2l-.001.555h4.223V2a1 1 0 0 1 1-1zM16 9.222H4v6.334a1 1 0 0 0 .883.993l.117.007h10a1 1 0 0 0 1-1V9.222zM5.888 4.555H5a1 1 0 0 0-1 1v1.667h12V5.556a1 1 0 0 0-.883-.994L15 4.556l-.889-.001v.556a1 1 0 0 1-1.993.117l-.007-.117v-.556H7.888v.556a1 1 0 0 1-1.992.117l-.007-.117-.001-.556z"
    />
  </svg>
);
